import React from 'react'
import { Button } from 'antd'
import { PlusOutlined } from '@ant-design/icons'
import { useDispatch, useSelector } from 'react-redux'
import { questionActions } from '../../../../../store/slices/question.slice'
import CreateQuestionDrawer from '../drawer/CreateQuestionDrawer'
import questionSelectors from '../../../../../store/selectors/question.selectors'
import useSubmissionGroups from '../../submissions/submission-groups/useSubmissionGroups'

const CreateQuestionButton = () => {
    const dispatch = useDispatch()
    const showCreateQuestionDrawer = useSelector(questionSelectors.showCreateQuestionDrawer)

    const { totalSubmissions } = useSubmissionGroups({ applyFilter: false })
    if (totalSubmissions) return null
    
    const handleCreateQuestion = () => {
        dispatch(questionActions.setShowCreateQuestionDrawer(true))
    }

    return (
        <>
            <Button 
                type="primary" 
                icon={<PlusOutlined />} 
                onClick={handleCreateQuestion}
                style={{ marginRight: 8 }}
            >
                Create
            </Button>
            {showCreateQuestionDrawer && <CreateQuestionDrawer />}
        </>
    )
}

export default CreateQuestionButton